import yup from '~/utils/validationMessages'

import { UserConsentTypeEnum } from '~/app/generated/graphql'
import { GT, gt } from '~/lib/gt'

export const contestMartiniSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  phoneNumber: yup
    .string()
    .matches(/^(\+?\d{1,3}[- ]?)?\d{9}$/, gt.tp('Error', 'Incorrect phone number format'))
    .required(),
  file: yup.array().min(1, gt.tp('Error', 'This field is required')).required(),
  text: yup.string().required(),
  eligibleToParticipate: yup.boolean().oneOf([true], gt.tp('Error', 'This field is required')),
  dataProcessing: yup.boolean().oneOf([true], gt.tp('Error', 'This field is required')),
  marketings: yup.boolean().oneOf([true], gt.tp('Error', 'This field is required')),
})

export const contestMartiniDefaultValues = {
  name: '',
  email: '',
  phoneNumber: '',
  file: [],
  text: '',
  eligibleToParticipate: false,
  dataProcessing: false,
  marketings: false,
}

export const getConsents = (gt: GT) => ({
  name: 'marketingConsentAccepted' as const,
  label: gt.tp(
    'RegisterForm',
    '{{ thankYouBold }} - I would like to use discount codes, receive notifications about RestaurantWeek®, FineDiningWeek® and other Festivals, and receive the eBook “BEST RESTAURANT PROVISIONS” as a gift {{ valuedAtBold }}, in connection with which I agree to send commercial information (e-mail/SMS)',
    {
      thankYouBold: `<b>${gt.tp('RegisterForm', 'Yes, thank you')}</b>`,
      valuedAtBold: `<b>${gt.tp('RegisterForm', '(valued at PLN 78)')}</b>`,
    }
  ),
  showMore: gt.tp(
    'RegisterForm',
    'by RestaurantWeek Sp. z o.o. and I acknowledge that I am 18 years of age or older and agree to receive content related to festival partners, including content related to alcohol brands (e.g., information about the event sponsor or the cocktail served at the dinner).'
  ),
  consentType: UserConsentTypeEnum.MarketingConsent,
})
